module.exports = __webpack_public_path__ + "static/img/15.7870738.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/zh/15.png
// module id = VdD7
// module chunks = 0